import React, { useEffect } from 'react';
import './App.css';
import { Outlet } from "react-router-dom";
import Header from "./components/header/header";
import './sass/app.scss';
import { useDispatch, useSelector } from "react-redux";
import { Section } from "./common/types/post.types";
import {updateSections} from './reducers/sectionsSlice';
import { getHierarchySectionsApi } from "./utils/api";

function App() {
  const sections: Section[] = useSelector((state: any) => state.sections.data)
  const dispatch = useDispatch()

  useEffect(() => {
    if (sections && sections.length === 0) {
      getHierarchySectionsApi().then(data => {
        dispatch(updateSections(data))
      })
    }
  }, [])

  return (
    <div className="App">
      <Header />
      <Outlet />
    </div>
  );
}

export default App;
